import { render, staticRenderFns } from "./GuestsDetails.vue?vue&type=template&id=be0a504c&"
import script from "./GuestsDetails.vue?vue&type=script&lang=js&"
export * from "./GuestsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports